import * as React from "react";

export default () => {
  return <div>Betalningsvillkor för den nya aviseringsinställningen.</div>;
};
